let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l4Sv7")).then(() => parcelRequire('gYTdV'));